import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled, { withTheme } from 'styled-components';

import { Badge } from '@ge/components/badge';
import { Icon, Icons } from '@ge/components/icon';
import { globalColors } from '@ge/tokens/colors';

const InputSearch = styled.div`
  display: inline-flex;
  flex: 1 1 300px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  width: 93%;
  padding: 5px 13px 0 14px;
  .search-icon{
    background-color: ${(props) => props.theme.entityDetails.siteSearchColor} !important;
    top: 16px;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    background-color: white;
    border-style: solid;
    border-width: 1px 0px 1px 1px;
    border-color: ${globalColors.grey11}
    left: 19px;
    padding: 8px;
    &:focus-within {
      background: cyan;
    }
    &:focus {
      outline: none;
      border-color: black;
      border-style: solid;
      border-width: 1px 0px 1px 1px;
    }
  }
`;

const Input = styled.input`
  border: 0;
  padding: 0.5rem 0.5rem 0.5rem 0;
  flex: 1;
  font-weight: 300;
  font-size: 15px;
  color: grey;
  font-family: 'Museo Sans';
  padding: 5px 5px 5px 30px;
  border: 1px solid ${globalColors.grey11};
  border-radius: 5px;

  background-color: ${(props) => props.theme.entityDetails.siteSearchColor};
  ::placeholder {
    font-size: 14px;
    color: #c3c3c3;
    right: 10px;
  }
  &:focus {
    outline: none;
    border: 1px solid black;
  }
  /* clears the ‘X’ from Internet Explorer */
  ::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  ::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  /* clears the ‘X’ from Chrome */
  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }
`;

const SearchIcon = styled(Icon).attrs((props) => ({
  size: 15,
  icon: Icons.SEARCH,
  color: props.theme.dataExplorer.filters.searchIconColor,
  rotate: -90,
  minWidth: '50px',
  textAlign: 'center',
}))`
  position: absolute;
  top: 11px;
  left: 24px;
`;

const COLOR_CODE = [
  {
    online: 'Online',
    available: 'Available',
    impacted: 'Impacted',
    tripped: 'Tripped',
  },
  {
    stopped: 'Stopped',
    netComm: 'No Comm',
    maintenance: 'Maintenance',
    repair: 'Repair',
  },
];

const SiteSearch = ({ onChangeHandler, theme, isAsset, filterText, placeholder, translateFn }) => {
  return (
    <>
      <InputSearch className="searchContainer">
        <SearchIcon />
        <Input
          className="searchBox"
          type="search"
          name="search"
          placeholder={placeholder}
          value={filterText}
          onChange={onChangeHandler}
        />
      </InputSearch>
      {!isAsset &&
        COLOR_CODE.map((e, i) => {
          return (
            <div className="sites" key={`__siteBadge${e}${i}`}>
              {Object.keys(e).map((key) => (
                <Fragment key={`_badge${key}`}>
                  <Badge
                    className="status-badge"
                    small
                    label={''}
                    color={theme.siteStatusBar[key]}
                  />
                  <p key={`_badgeame${key}`}>{translateFn(`state.${key}`, e[key])}</p>
                </Fragment>
              ))}
            </div>
          );
        })}
      <hr className="sitesSearchHr" />
    </>
  );
};

SiteSearch.propTypes = {
  onChangeHandler: PropTypes.func,
  theme: PropTypes.instanceOf(Object),
  isAsset: PropTypes.bool,
  filterText: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  translateFn: PropTypes.func.isRequired,
};

SiteSearch.defaultProps = {
  onChangeHandler: () => null,
  filterText: '',
};

export default withTheme(SiteSearch);
